export default __webpack_public_path__ + "static/media/kevin-headshot.4029059d.png";